export const ADD_VIDEO = 'videos/ADD_VIDEO'
export const SET_VIDEO_UPLOADING_STATUS = 'videos/SET_VIDEO_UPLOADING_STATUS'
export const DELETE_VIDEO = 'videos/DELETE_VIDEO'
export const CLEAR_VIDEOS_STATE = 'videos/CLEAR_VIDEOS_STATE'
